<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "SalesSurvey2025",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  